import React, { Component } from 'react';
import List from './list';
import Header from './header';
import ReactTooltip from 'react-tooltip';

const skills = [
  { id: 1, name: 'HTML/CSS/SCSS' },
  {
    id: 14,
    name: 'Databases',
    children: [
      { id: 15, name: 'SQL' },
      { id: 16, name: 'PostgresSql' },
      { id: 21, name: 'RethinkDB' },
      { id: 18, name: 'MongoDB' },
      { id: 20, name: 'Mongoose' },
    ]
  },
  {
    id: 2,
    name: 'Ruby',
    children: [
      { id: 3, name: 'Rails' },
      { id: 4, name: 'RSpec' },
      { id: 5, name: 'Capybara' }
    ]
  },

  {
    id: 6,
    name: 'Javascript',
    children: [
      { id: 7, name: 'jQuery' },
      { id: 8, name: 'React' },
      { id: 9, name: 'Angular' },
      { id: 10, name: 'Redux' },
      { id: 19, name: 'Node.js' },

    ]
  },
  { id: 11, name: 'Git' },
  { id: 12, name: 'Heroku' },
  { id: 13, name: 'Foundation' },
  { id: 17, name: 'Bootstrap' }
];

class About extends Component {
  render() {
    return (
      <div id="about">
        <ReactTooltip />
        <Header title={'About'} />
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <h2 className="sans">
                <strong>Me?</strong>
              </h2>
              <p className="mono">
                Former tennis professional turned <span style={{ color: '#cac712', textShadow: '2px 1px black' }}>JavaScript</span> fanatic.{' '}
                <br />
                Musician. Creator. Learner.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <h2 className="sans">
                <strong>Skills</strong>{' '}
                {/* <small>
                  <span data-tip="Pretty much..." className="pink-underline" />
                </small> */}
              </h2>
              <List items={skills} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <h2 className="sans">
                <strong>Also...</strong>
              </h2>
              <p className="mono">
                I am continually studying, learning and applying new programming concepts.
                I am dedicated and focused on my development as a programmer. Currently, I am learning about Machine Learning, Neural Networks and AI.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 col-md-offset-3">
              <p className="lead mono" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default About;



// WEBPACK FOOTER //
// ./src/components/about.js